import * as React from 'react';
import { Paragraph } from '../../../../elements';
import TwoColRow from './TwoColRow';
import personnummer from 'personnummer.js';
const NameAndNationalIdRow = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    React.createElement(TwoColRow, { label: i18n('common.fullName'), value: value.fullName }),
    React.createElement(TwoColRow, { label: i18n('common.nationalid'), value: personnummer
            .normalise(value.nationalId, { normaliseFormat: 'YYYYMMDD-NNNN' }) }),
    React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.taxAgency')} (${formatDate(value.verificationDate)})` }),
    value.comment != '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
        React.createElement(Paragraph, { bold: true }, i18n('common.note')),
        React.createElement("div", { className: 'ReadReportContent__NotationContent' },
            React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
export default NameAndNationalIdRow;
